export const currencies = ['USD', 'EUR', 'GBP'];
